import { request } from "../../../apis";

export const apiGetBanner = (): any =>
  request("get", `/api/banner/list`, null, true);
